import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import ContentOpportunityPane from '../../components/Modules/ContentOpportunityPane/ContentOpportunityPane'
import ContentMarkerPane from '../../components/Modules/ContentMarkerPane/ContentMarkerPane'
import BrokenLinkFixer from '../BrokenLinkFixer/BrokenLinkFixer';
import StaleContentMarker from '../StaleContentMarker/StaleContentMarker';
import RefinedContentMarker from '../RefinedContentMarker/RefinedContentMarker';
import ArchivingContentMarker from '../ArchivingContentMarker/ArchivingContentMarker';
import HackathonBrokenLinkFixer from '../HackathonBrokenLinkFixer/HackathonBrokenLinkFixer';
import TextCrawlerFixer from '../TextCrawlerFixer/TextCrawlerFixer';
import HealingCompletePage from './HealingComplete/HealingCompletePage'
import { AuthenticatedTemplate } from "@azure/msal-react";
import { useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser'
import MenuBar from '../Modules/MenuBar/MenuBar'
import CommonPageEntry from '../Modules/CommonPageEntry/CommonPageEntry';

export function RouterPage() {
  // auto login
  useMsalAuthentication(InteractionType.Redirect);

  return (
    <Routes>
      <Route element={<CommonPageRuter />}>
        <Route path='/' element={<Navigate to='/apps/brokenlinkfixer' />} />
        <Route path='/apps/brokenlinkfixer' element={<CommonPageEntry title='Broken Link' component={BrokenLinkFixer} status="" />} />
        <Route path='/apps/hackathonbrokenlinkfixer' element={<CommonPageEntry title='Hackathon Broken Link' component={HackathonBrokenLinkFixer} status="" />} />
        <Route path='/apps/textfixer' element={<CommonPageEntry title='Text Crawler' component={TextCrawlerFixer} status="" />} />
      </Route>
      <Route element={<CommonCCISPageRuter />}>
        <Route path='/apps/stale' element={<CommonPageEntry title='stale' component={StaleContentMarker} status="CCIS" />} />
        <Route path='/apps/refined' element={<CommonPageEntry title='refined' component={RefinedContentMarker} status="CCIS" />} />
        <Route path='/apps/archiving' element={<CommonPageEntry title='archiving' component={ArchivingContentMarker} status="CCIS" />} />
      </Route>
      <Route element={<FinishPageRuter />}>
        <Route path='/apps/close' element={<HealingCompletePage />} />
      </Route>
    </Routes>
  )
}

/**
 * route for common page
 * @returns 
 */
const CommonPageRuter = () => (
  <div>
    <AuthenticatedTemplate>
      <MenuBar />
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm6 ms-md4 ms-lg4 sidenav">
          <ContentOpportunityPane ></ContentOpportunityPane>
        </div>
        <div className="ms-Grid-col ms-sm6 ms-md8 ms-lg8 msacct-content">
          <Outlet />
        </div>
      </div>
    </AuthenticatedTemplate>
  </div>
);

/**
 * route for common CCIS page
 * @returns 
 */
const CommonCCISPageRuter = () => (
  <div>
    <AuthenticatedTemplate>
      <MenuBar content="contentMarker" />
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm3 ms-md3 ms-lg3" style={{ paddingRight: "0px" }}>
          <ContentMarkerPane></ContentMarkerPane>
        </div>
        <div className="ms-Grid-col ms-sm9 ms-md9 ms-lg9 msacct-content">
          <Outlet />
        </div>
      </div>
    </AuthenticatedTemplate>
  </div>
);

/**
 * route for ticket download
 * @returns 
 */
const FinishPageRuter = () => (
  <div>
    <AuthenticatedTemplate>
      <MenuBar />
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 msacct-content">
        <Outlet />
      </div>
    </AuthenticatedTemplate>
  </div>
);

